import deepSnakeizeKeys from "../utils/object/deepSnakeizeKeys.js";

const toUrlSearchParams = (params) => {
  const snakeCasedParams = deepSnakeizeKeys(params || {});
  return Object.keys(snakeCasedParams).reduce((acc, key) => {
    const value = snakeCasedParams[key];
    if (Array.isArray(value)) {
      value.forEach(v => acc.append(key, v));
    } else {
      acc.append(key, value);
    }
    return acc;
  }, new URLSearchParams());
};

export default toUrlSearchParams;
